import { memo } from 'react'
import { useTranslation } from 'next-i18next'
import dynamic from 'next/dynamic'

import { Grid } from '@/styles/grid'
import Title from '@/components/common/Title'

import { Container, TitleWrapper } from './index.styled'

const ContactInfo = dynamic(() => import('./ContactInfo'), { ssr: false })
const Form = dynamic(() => import('./Form'), { ssr: false })

function ContactSection({ parkingName }: { parkingName?: string }) {
  const { t } = useTranslation('common')

  return (
    <section id="contact-section" aria-labelledby="contact-section-title">
      <Container>
        <TitleWrapper>
          <Title id="contact-section-title" text={t('contact.title')} />
        </TitleWrapper>
        <Grid>
          <ContactInfo />
          <Form parkingName={parkingName} />
        </Grid>
      </Container>
    </section>
  )
}

export default memo(ContactSection)
